<button type="button" (click)="onConfirm()">{{'acceptButton' | translate}}</button>
